import { ref } from 'vue'
import ApplicationWindowService from '@/services/applicationWindow.service'

const pendingTeamApplicationsCount = ref(null)

export function useTeamApplications () {
  function fetchPendingTeamApplicationsCount () {
    ApplicationWindowService.pendingCount().then(response => {
      pendingTeamApplicationsCount.value = response.data?.count
    })
  }

  return {
    fetchPendingTeamApplicationsCount,
    pendingTeamApplicationsCount
  }
}
